import React, { useState, useEffect } from 'react';

const AdvancedSettings = () => {
  const [buttonText, setButtonText] = useState('Opslaan');
  const [isSaved, setIsSaved] = useState(true); // Track if changes are saved
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false); // Track if history deletion success message should be shown

  useEffect(() => {
    // Add beforeunload event listener
    const handleBeforeUnload = (event) => {
      if (!isSaved) {
        const message = 'U hebt onopgeslagen wijzigingen. Weet u zeker dat u de pagina wilt verlaten?';
        event.returnValue = message; // Standard for most browsers
        return message; // For some browsers
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isSaved]);

  const handleSave = () => {
    // Change the button text to "Opgeslagen" and revert after 3 seconds
    setButtonText('Opgeslagen');
    setIsSaved(true); // Mark changes as saved
    setTimeout(() => {
      setButtonText('Opslaan');
    }, 3000);
  };

  const handleClearHistory = () => {
    const confirmed = window.confirm('Weet u zeker dat u de volledige geschiedenis wilt verwijderen?');
    if (confirmed) {
      localStorage.removeItem('history');
      setShowDeleteSuccess(true); // Show delete success message
      setTimeout(() => {
        setShowDeleteSuccess(false); // Hide delete success message after 5 seconds
      }, 5000);
      // Optionally, you can also clear state if necessary
      // setHistory([]);
    }
  };

  return (
    <div>
      {/* Inhoud voor geavanceerde instellingen */}
      <div className="banner-settings-wrapper">
        <h1>Geavanceerde instellingen</h1>
          <div className="banner-settings-switch">
            <div className="banner-settings-inner-content">
              <div className="banner-settings-inner-content-details_input">
                {/* Knop voor het verwijderen van de geschiedenis */}
                <div className="save-button-div">
                  <button className="copy-button" onClick={handleClearHistory}>Verwijder geschiedenis</button>
                </div>
                {/* Delete success message */}
                {showDeleteSuccess && (
                  <div className="delete-success-message">
                    <p>De geschiedenis is succesvol verwijderd.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        <div className="save-button-div">
          <button className="save-button" onClick={handleSave}>{buttonText}</button>
        </div>
      </div>
    </div>
  );
};

export default AdvancedSettings;

